/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_SqftInputs */

const en_admin_resources_sqft = /** @type {(inputs: Admin_Resources_SqftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sqft`)
};

const de_admin_resources_sqft = /** @type {(inputs: Admin_Resources_SqftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sqft`)
};

const es_admin_resources_sqft = /** @type {(inputs: Admin_Resources_SqftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pies cuadrados`)
};

const fr_admin_resources_sqft = /** @type {(inputs: Admin_Resources_SqftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pieds carrés`)
};

const nl_admin_resources_sqft = /** @type {(inputs: Admin_Resources_SqftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sqft`)
};

/** @type {(inputs: Admin_Resources_SqftInputs) => LocalizedString} */
const it_admin_resources_sqft = en_admin_resources_sqft;

/** @type {(inputs: Admin_Resources_SqftInputs) => LocalizedString} */
const pt_br2_admin_resources_sqft = en_admin_resources_sqft;

/** @type {(inputs: Admin_Resources_SqftInputs) => LocalizedString} */
const pl_admin_resources_sqft = en_admin_resources_sqft;

/** @type {(inputs: Admin_Resources_SqftInputs) => LocalizedString} */
const hu_admin_resources_sqft = en_admin_resources_sqft;

/** @type {(inputs: Admin_Resources_SqftInputs) => LocalizedString} */
const ro_admin_resources_sqft = en_admin_resources_sqft;

/**
* | output |
* | --- |
* | "sqft" |
*
* @param {Admin_Resources_SqftInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_sqft = /** @type {((inputs?: Admin_Resources_SqftInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_SqftInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_sqft(inputs)
	if (locale === "de") return de_admin_resources_sqft(inputs)
	if (locale === "es") return es_admin_resources_sqft(inputs)
	if (locale === "fr") return fr_admin_resources_sqft(inputs)
	if (locale === "nl") return nl_admin_resources_sqft(inputs)
	if (locale === "it") return it_admin_resources_sqft(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_sqft(inputs)
	if (locale === "pl") return pl_admin_resources_sqft(inputs)
	if (locale === "hu") return hu_admin_resources_sqft(inputs)
	return ro_admin_resources_sqft(inputs)
});
export { admin_resources_sqft as "admin.resources.sqft" }